/* Rise8 header — the pick and the strings.
   Ported from design/build/home_build.py STRING_JS by hand; if the mockup changes, change
   both. The mockup scoped this per `.mock` because its prototype holds fourteen headers in
   one document; a real page has exactly one, so the wrapper collapses to the document.

   Only the ringing string is redrawn and the loop stops dead when it falls silent, so an idle
   page runs no code at all. The pick itself moves on a CSS transform — the compositor handles
   that, not JavaScript.

   Two things that have bitten this code before, both still true:
     * `data-string` can legitimately be 0 (the low E). `+v || 5` treats that as falsy and
       rings the wrong string. Hence num().
     * `mouseenter` does not bubble, so the listener goes on each link, not the nav.
*/
/* The pick slides to whichever nav item you point at and the matching string rings.
   Only the ringing string is ever redrawn, and the loop stops dead when it falls silent,
   so an idle page runs no code. The pick itself moves on a CSS transform — the compositor
   handles that, not JavaScript. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  (function (mock) {
    var svg = mock.querySelector('.mk-string');
    if (!svg) return;
    var paths = svg.querySelectorAll('path');
    var pick  = mock.querySelector('.mk-pick');
    var nav   = mock.querySelector('.mk-links');
    var Y = [6, 18, 30, 42, 54, 66];
    var W = 1000, N = 48;
    var raf = null, t0 = 0, pluck = .5, amp = 0, hz = 1, idx = 5, hideT = null;

    function rest(i) { paths[i].setAttribute('d', 'M0 ' + Y[i] + ' L' + W + ' ' + Y[i]); }

    function frame(now) {
      var t = (now - t0) / 1000;
      var a = amp * Math.exp(-t * (2.2 + hz * 0.9));
      if (a < 0.06) { rest(idx); if (idx !== 5) paths[idx].style.stroke = ''; raf = null; return; }
      var mid = Y[idx], osc = Math.cos(2 * Math.PI * hz * 7 * t), d = 'M0 ' + mid;
      for (var k = 1; k <= N; k++) {
        var x = k / N;
        var env = x < pluck ? x / pluck : (1 - x) / (1 - pluck);
        d += ' L' + (x * W).toFixed(1) + ' ' + (mid + a * env * osc).toFixed(2);
      }
      paths[idx].setAttribute('d', d);
      if (idx !== 5) {
        var g = Math.min(1, a / amp);
        paths[idx].style.stroke = 'rgba(215,39,46,' + (0.22 + 0.78 * g).toFixed(2) + ')';
      }
      raf = requestAnimationFrame(frame);
    }

    function num(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }
    function strike(fraction, fret, stringIdx) {
      if (reduce) return;
      if (raf) { cancelAnimationFrame(raf); rest(idx); if (idx !== 5) paths[idx].style.stroke = ''; }
      idx = stringIdx;
      pluck = Math.min(.94, Math.max(.06, fraction));
      hz  = 1 + (5 - idx) * 0.30 + (fret - 3) * 0.10;
      amp = 8.0 - (5 - idx) * 0.9;
      t0  = performance.now();
      raf = requestAnimationFrame(frame);
    }

    mock.querySelectorAll('.mk-links a').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var r = a.getBoundingClientRect(), s = svg.getBoundingClientRect();
        var center = r.left + r.width / 2 - s.left;
        if (pick) {
          clearTimeout(hideT);
          pick.classList.add('is-on');
          pick.style.transform = 'translateX(' + (center - 15.5).toFixed(1) + 'px) rotate(8deg)';
        }
        strike(center / s.width, num(a.dataset.fret, 3), num(a.dataset.string, 5));
      });
    });
    if (nav && pick) {
      nav.addEventListener('mouseleave', function () {
        hideT = setTimeout(function () { pick.classList.remove('is-on'); }, 220);
      });
    }
    for (var i = 0; i < paths.length; i++) rest(i);
  })(document);
})();
